import { formatCurrency } from '../../data/mockData';
import { formatPrice, formatQty, lineAmount } from '../../utils/soldBy';
import cardStyles from './DriverCards.module.css';

export default function DriverBillSummary({ order, title = 'Ordered Items & Bill Preview' }) {
  return (
    <section className={cardStyles.card}>
      <p className={cardStyles.cardLabel}>{title}</p>
      <div className={cardStyles.itemsList}>
        {order.items.map((it) => (
          <div className={cardStyles.itemRow} key={it.productId}>
            <span>{it.name} · {formatQty(it.qty, it)} × {formatPrice(it, formatCurrency)}</span>
            <span>{formatCurrency(lineAmount(it.price, it.qty))}</span>
          </div>
        ))}
      </div>
      <div className={cardStyles.billDivider} />
      <div className={cardStyles.billRow}>
        <span>Subtotal</span>
        <span>{formatCurrency(order.subtotal)}</span>
      </div>
      <div className={cardStyles.billRow}>
        <span>Delivery Fee</span>
        <span>{order.deliveryFee === 0 ? 'Free' : formatCurrency(order.deliveryFee)}</span>
      </div>
      <div className={cardStyles.billDivider} />
      <div className={cardStyles.totalRow}>
        <span>{order.paymentMethod === 'Cash on Delivery' ? 'Total (Collect COD)' : 'Total'}</span>
        <span>{formatCurrency(order.total)}</span>
      </div>
    </section>
  );
}
